<template>
  <div>
    <Basket v-if="groupsBasket.length || partsBasket.length" :groups="groupsBasket" :partTypes="partsBasket" :title="'Grupos Seleccionados'" :titlePart="'Tipo de partes Seleccionados'" :model="'groupsBasket'"
      @Update="remove" />
    <v-layout row justify-space-between v-resize="onResize">
      <v-card width="100%">
        <v-window v-model="window">
          <v-window-item :value="1">
            <Category class="pa-2" :categories="categories" @Update="selectCategory" :isMobile="isMobile" />
          </v-window-item>
          <v-window-item :value="2">
            <v-card-title @click="window = 1">
              <v-btn class="action white--text text-xs-center primary">
                <v-icon color="white">chevron_left</v-icon>
                <small left>{{ $t("Catalog.back") }}</small>
              </v-btn>
            </v-card-title>
            <Group class="pa-2" :groups="activeCategory" @PreviewFn="toggleGroups" @Update="expandGroup" @click="selectGo"
              :isMobile="isMobile" :title="activeCategoryTitle" :model="'groupsBasket'" />
          </v-window-item>
          <v-window-item :value="3">
            <v-card-title @click="backToGroupList()">
              <v-btn class="action white--text text-xs-center primary">
                <v-icon color="white">chevron_left</v-icon>
                <small left>{{ $t("Catalog.back") }}</small>
              </v-btn>
              <!-- <v-btn color="primary" dark @click="selectAllPartTypes()"  class="mr-4 mt-2">
                <v-icon left class="subPrimary--text mr-2">library_add_check</v-icon>
                <small>{{ $t('Catalog.List.PartTypes.SelectAll') }}</small>
              </v-btn> -->
              <v-btn color="primary" dark @click="deleteAllPartTypes()" v-if="totalPartBasketCount >= 1" class="mr-4 mt-2">
                <v-icon left class="subPrimary--text mr-2">delete_outline</v-icon>
                <small>{{ $t('Catalog.List.PartTypes.Clear') }}</small>
              </v-btn>
            </v-card-title>
            <PartType class="pa-2" :partType="activeGroup" @click="toggleParts" :isMobile="isMobile"
              :categoryTitle="activeCategoryTitle" :groupTitle="group_title" :model="'partsBasket'" />
          </v-window-item>
        </v-window>
      </v-card>
    </v-layout>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";


export default {
  name: "DefaultCatalog",
  data() {
    return {
      window: 1,
      activeCategory: null,
      activeCategoryTitle: null,
      activeGroup: [],
      isMobile: false,
      route: this.$route.name,
      uniquepartDescriptionsArray: [],
      group_title: null

    }
  },
  components: {
    Category: () => import('./List/Mobile/Category.mobile'),
    Group: () => import('./List/Mobile/Group.mobile'),
    PartType: () => import('./List/Mobile/PartType.mobile'),
    Basket: () => import('./List/Mobile/Basket.mobile')
  },
  computed: {
    ...mapState({
      groupsBasket: state => state.parts.groupsBasket,
      partsBasket: state => state.parts.partsBasket,
      selected_parts_count: state => state.parts.selected_count,
      uniquepartsDescriptions: state => state.parts.uniquepartsDescriptions,
    }),
    ...mapGetters({
      unorderedCategories: "parts/categories",
      getCategoryItems: "parts/getCategoryItems",
      getGroupItems: "parts/getGroupItems",
      basicCatalogRequest: 'parts/basicCatalogRequest',
      totalGroupBasketCount: "parts/totalGroupBasketCount",
      totalPartBasketCount: "parts/totalPartBasketCount",
      onlyGroups: 'parts/onlyGroups',
      toggleSelectedIconBoolean:'parts/toggleSelectedIconBoolean',
      uniquepartsDescriptionsCount: 'parts/uniquepartsDescriptionsCount',
      vehicleForInquiry: 'vehicle/vehicleForInquiry'
    }),
    // CATEGORIES LIST 
    categories() {
      return this.$lodash.orderBy(this.unorderedCategories, "name");
    },
    partsList() {
      return this.groupsBasket
        .map(group => this.$lodash.orderBy(this.getGroupItems(group), "items", ['desc']))
        .reduce((acc, cur) => acc.concat(cur), []);
    }
  },
  methods: {
    ...mapActions({
      INQUIRY: "parts/INQUIRY",
      TOGGLE_SELECTION_GROUP: "parts/TOGGLE_SELECTION_GROUP",
      TOGGLE_SELECTION_SINGLE_PARTS_TYPES: "parts/TOGGLE_SELECTION_SINGLE_PARTS_TYPES",
      TOGGLE_SELECTION_ALL_PARTS_TYPES: "parts/TOGGLE_SELECTION_ALL_PARTS_TYPES",
      TOGGLE_SELECTION_ALL_PARTS_TYPES_IN_GROUPS: "parts/TOGGLE_SELECTION_ALL_PARTS_TYPES_IN_GROUPS",
      RESET_PARTS_TYPES: "parts/RESET_PARTS_TYPES",
      GET_UNIQUE_PART_DESCRIPTIONS: "parts/GET_UNIQUE_PART_DESCRIPTIONS",
      RESET_UNIQUE_PART_DESCRIPTIONS_ARRAY: "parts/RESET_UNIQUE_PART_DESCRIPTIONS_ARRAY"
    }),

    //CATEGORIES 
    selectCategory(category) {
      this.window = 2;
      this.activeCategoryTitle = category.name;
      this.activeCategory = this.$lodash.orderBy(
        this.getCategoryItems(category.id),
        "name"
      );
    },
    //GROUPS

    async toggleGroups(group, typeAction) {
      if(typeAction === 1) {
        const index_group = this.groupsBasket.findIndex(i => i.id === group.id);
        if(index_group === -1) {
          await this.getUniquePartDescriptions(group);
          await  this.selectAllPartTypes(group, typeAction);
          await this.expandGroup(group);
          this.TOGGLE_SELECTION_GROUP({ model: "groupsBasket", group }) 
        } else {
          this.TOGGLE_SELECTION_GROUP({ model: "groupsBasket", group }) 
        }
        if (this.totalGroupBasketCount < 1) {
          this.RESET_PARTS_TYPES();
        }
      } else if(typeAction === 2){
          const index_partTypeUnique = this.uniquepartsDescriptions.findIndex(i => i.group.id === group.id);
          if(index_partTypeUnique === -1){
            await this.getUniquePartDescriptions(group);
          } else {
            const unique = this.uniquepartsDescriptions.find(i => i.group.id === group.id);
            this.uniquepartDescriptionsArray = unique.items
          }
          await  this.selectAllPartTypes(group, typeAction);
          await this.expandGroup(group);
          const index_group = this.groupsBasket.findIndex(i => i.id === group.id);
          if(index_group === -1){
            this.TOGGLE_SELECTION_GROUP({ model: "groupsBasket", group }) 
          }

      }
    },

    async expandGroup(group) {
      this.group_title = group.name
      this.uniquepartsDescriptions.find(partGroup => {
        partGroup.items.find(ptItems => {
           if(parseInt(ptItems.groupNum) === group.id){
             this.activeGroup.push(ptItems)
           }
        }) 
      })
      this.window = 3;    
    },

    selectAllPartTypes(group, typeAction) {
      if(typeAction === 2){
        if(this.uniquepartsDescriptionsCount > 0) {
          const type = 1
          const uniquepartDescriptions = this.uniquepartDescriptionsArray;
          this.TOGGLE_SELECTION_ALL_PARTS_TYPES({ model: 'partsBasket', uniquepartDescriptions, type})
        } 
      } else if(typeAction === 1) {
        const index = this.groupsBasket.findIndex(i => i.id === group.id)
    
        if(index === -1){
          if(this.uniquepartsDescriptionsCount > 0) {
            const type = 1
            const uniquepartDescriptions = this.uniquepartDescriptionsArray;
            this.TOGGLE_SELECTION_ALL_PARTS_TYPES({ model: 'partsBasket', uniquepartDescriptions, type})
          } 
        } else {
          this.deselectAllPartTypeByGroup(group)
        }
      }

    },

    async getUniquePartDescriptions(groups){
      const groups_with_parts = this.onlyGroups.find(g => g.id === groups.id )

      const groupRequest = {
        vehicle: this.vehicleForInquiry,
        partGroups: [{
          id: groups_with_parts.id,
          name: groups_with_parts.name,
          engineCode: groups_with_parts.engineCode
        }]
      }

      const response = await this.GET_UNIQUE_PART_DESCRIPTIONS({ requestArray: groupRequest, group: groups})

      if(response.data?.status === 404){
        const arrayUnique = {
          group: { id: groups.id, name: groups.name },
          items: [{groupNum: groups.id, id: 1, name: "NO HAY TIPOS DE PARTES DISPONIBLES"}]
        }
        this.uniquepartDescriptionsArray = arrayUnique.items
      } else {
        this.uniquepartDescriptionsArray = response.data.items
      }
      return response
    },

    deselectAllPartTypeByGroup(group){
        const groups = group
        this.TOGGLE_SELECTION_ALL_PARTS_TYPES_IN_GROUPS({ model: 'partsBasket', groups})
    },

    inGroupBasket({model, group }) {
      return (this.$store.state.parts[model].findIndex(i => i.id == group.id)) !== -1
    },

    async selectGo( {model, group }) {
      if (!this.inGroupBasket({model, group })) {
        await this.TOGGLE_SELECTION_GROUP({ model, group });
        await this.getUniquePartDescriptions(group);
        await  this.selectAllPartTypes(group, 2);
      }
      if (this.totalGroupBasketCount >= 1) {
        this.selectAllPartTypes(group);
      } 
      await this.INQUIRY({request: this.basicCatalogRequest, page: 1, size: 25, group_by: 'manufacturer' });
    },
    //  //SELECT PARTS TYPES
    
    remove(group, model) {
      this.groupsBasket.splice(this.groupsBasket.indexOf(group, model), 1);
      this.RESET_PARTS_TYPES();
    },

    //PARTS TYPES 
    toggleParts({model, part, type}) {
      this.TOGGLE_SELECTION_SINGLE_PARTS_TYPES({ model, part, type });
    },
    deleteAllPartTypes(){
        if(this.totalPartBasketCount >= 1){
          this.RESET_PARTS_TYPES();
        }
    },

    //SHARED METHODS
    onResize() {
      if (window.innerWidth < 760)
        this.isMobile = true;
      else
        this.isMobile = false;
    },

    backToGroupList(){
      this.window = 2;
      // this.RESET_UNIQUE_PART_DESCRIPTIONS_ARRAY()
      this.activeGroup = [];
    }
  }
};
</script>
